class OutOfServiceHospital {
  constructor(note, totalDuration, hospitalId, isActive) {
    this.note = note;
    this.totalDuration = totalDuration;
    this.hospitalId = hospitalId;
    this.isActive = isActive;
  }
}
export default {
  OutOfServiceHospital,
};
